import styled from "styled-components";

export const Container = styled.div<{ $disabled?: boolean }>`
	position: relative;
	//font-size: 14px;
	font-size: clamp(1px, 3dvw, 22px);
	margin-top: 1.2em;
	overflow: hidden;
	display: flex;
	box-shadow: 0em 0.2em 0.2em 0em rgba(0, 0, 0, 0.15);
	border-radius: 12px;
	cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
	opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
	pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};

	@media (min-width: 820px) {
		font-size: clamp(1px, 1dvw, 12px);
		margin: 0em 2em;
		width: 95%;
		max-width: 680px;
	}
`;

export const BannerImage = styled.img`
	position: relative;
	top: 0em;
	width: 100%;
	height: 100%;
`;

export const CustomButtom = styled.img`
	position: absolute;
	top: 10%;
	right: 2%;
	z-index: 2;
	cursor: pointer;
	width: 2.5em;

	/* @media (min-width: 720px) {
		top: 32%;
		width: 25px;
		right: 20%;
	}
	@media (min-width: 1300px) {
		width: 30px;
		right: 25%;
	} */
`;

export const Brush = styled.div<{ image?: string }>`
	position: absolute;
	bottom: 0px;
	width: 100%;
	max-height: 40px;
	content: url(${(props) => props.image});
`;
